/**
 * kikute ウィジェット ローダ (w.js) — E5-S1
 *
 * ホストサイトが <script src="https://cdn.kikute.com/w.js" data-kikute-key="pk_..."> で
 * 読み込む薄いローダ。本体 (w-core-{contentHash}.js) を SRI 付き <script> で注入する。
 *
 * 2 段バンドルの狙い (ADR-023 §2):
 *   - ローダ (w.js) は短命キャッシュ (max-age=3600) で URL 不変 → タグ 1 行を貼り替えなくてよい
 *   - 本体 (w-core-{hash}.js) は immutable 長期キャッシュ + content hash でキャッシュバスト
 *   - 本体の SHA-384 をローダに焼き込み (integrity) 改竄を検知
 *
 * CORE_URL / CORE_HASH はビルド時に esbuild の define で注入する
 * (デプロイ時に CDN ドメイン + content hash を確定)。
 */

declare const __CORE_URL__: string;
declare const __CORE_HASH__: string;

const CORE_URL = __CORE_URL__;
const CORE_HASH = __CORE_HASH__;

function injectCore(): void {
  // 二重注入防止
  if (document.querySelector('script[data-kikute-core]')) return;

  const script = document.createElement('script');
  script.src = CORE_URL;
  script.async = true;
  script.setAttribute('data-kikute-core', '');
  // SRI: 本体の改竄を検知 (ハッシュ不一致ならブラウザが実行を拒否)
  if (CORE_HASH) {
    script.integrity = CORE_HASH;
    script.crossOrigin = 'anonymous';
  }
  // ローダを読み込んだ <script> の data-* 属性を本体に引き継ぐ
  // (本体側 config.ts が現在の <script data-kikute-key> を探すため、属性をミラーする)
  //
  // ⚠️ このミラーと config.ts のセレクタは **必ず同じ prefix** にすること。
  // 片方だけ変えると w.js 経由でキーが届かず「キーが無い」と判定されて
  // ウィジェットが起動しない (計画書 §2.2 / R1)。
  const loaderTag =
    document.currentScript ??
    document.querySelector('script[data-kikute-key]') ??
    document.querySelector('script[src*="/w.js"]');
  if (loaderTag instanceof HTMLElement) {
    for (const attr of Array.from(loaderTag.attributes)) {
      if (attr.name.startsWith('data-kikute-')) script.setAttribute(attr.name, attr.value);
    }
  }
  document.head.appendChild(script);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', injectCore, { once: true });
} else {
  injectCore();
}
